import React from 'react';

import { useClassnames } from '@lumapps/classnames';
import { Text, Theme } from '@lumapps/lumx/react';
import { useMetadataLink } from '@lumapps/metadata/hooks/useMetadataLink';

import { MetadataLinkProps } from '../../types';

import './index.scss';

const CLASSNAME = 'metadata-link';

/**
 * Link to the search filtering by metadata
 */
export const MetadataLink: React.FC<MetadataLinkProps> = ({
    metadata,
    theme = Theme.light,
    contentTypeId,
}: MetadataLinkProps): React.ReactElement => {
    const { block } = useClassnames(CLASSNAME);
    const route = useMetadataLink(metadata, contentTypeId);

    if (route) {
        const { LinkAs, ...props } = route;
        return (
            <LinkAs {...props} className={block({ [`theme-${theme}`]: true, 'is-link': true })}>
                <Text as="span" truncate>
                    {metadata.rootName ? `${metadata.rootName} / ${metadata.name}` : `${metadata.name}`}
                </Text>
            </LinkAs>
        );
    }

    return (
        <Text as="span" className={block({ [`theme-${theme}`]: true })}>
            <Text as="span" truncate>
                {metadata.rootName ? `${metadata.rootName} / ${metadata.name}` : `${metadata.name}`}
            </Text>
        </Text>
    );
};
